'use strict';

const Mixin = require('./mixin');
const trackingPageFlowUtils = require('../utils/flow_tracking/tracking.page.flow.utils');

module.exports = new Mixin({
    afterConstructView() {
        this.registerTrackingPageFlow();
    },
    registerTrackingPageFlow(policy) {
        trackingPageFlowUtils.registerWidget(policy);
    },
    launchAppearancesTracking() {
        trackingPageFlowUtils.launchAppearancesTracking(this);
    },
});
